import widgetRows from '../data/widgetRows';
import { themes, tags } from '../data/initialValues';
import { capitalize } from '../utils/utils';

const {
  badgeStart,
  badgeEnd,
  linkStart,
  linkEnd,
  lineBreak,
} = tags;


const scenario = {

  steps: {
    completionTimestamp: 'survey',
    list: {
      first : [{
        id: 1,
        type: 'action',
        text: [
          'Take a look at the current dashboard UI.',
          <br />,
          <br />,
          'Get familiar with how the data is displayed in the widgets - what’s shown, how it’s structured, and how key metrics are presented.'
        ],
        task: 'first'
      },
      {
        id: 2,
        type: 'action',
        text: 'Great! Now click on the Next button to move to the new design! ',
        task: 'first'
      },
      {
        id: 3,
        type: 'action',
        task: 'first',
        text: [
          'Now, explore the new dashboard design.',
          <br />,
          <br />,
          'As you explore the new design, think about what’s easier or harder to understand, what changed in terms of layout or visuals, and how the new design compares to what you’re used to in your day-to-day work. '
        ]
    }],
      second : [{
        id: 4,
        type: 'action',
        text: 'Locate and open the App switcher. ',
        task: 'second'
      },
      {
        id: 5,
        type: 'action',
        text: 'Locate and open the domain switcher.',
        task: 'second'
      },
      {
        id: 6,
        type: 'action',
        text: 'Great! Now click on the Next button to move to the new design!',
        task: 'second'
      },
      {
        id: 7,
        type: 'action',
        text: 'Locate and open the App switcher in the new design.',
        task: 'second'
      },
      {
        id: 8,
        type: 'action',
        text: 'Locate and open the Domain switcher in the new design.',
        task: 'second'
      },
      {
        id: 9,
        type: 'action',
        
        text: [
          'We also have a forward-looking feature we’d like you to explore - Projects:',
          <br />,
          <br />,
          'Projects are slices of your infrastructure. They allow you to create VMs and other entities within the scope of the project. You can create different projects for different types of workloads, departments, or tenants.',
          <br />,
          <br />,
          'Locate and open the Project switcher in the new design.'
        ],
        task: 'second'
      }

    ],
    third : [{
      id: 10,
      type: 'action',
      text: 'Navigate to the VMs Alerts page using the current menu.',
      task: 'third'
    },
    {
      id: 11,
      type: 'action',
      text: 'Great! Now click on the Next button to move to the new design!',
      task: 'third'
    },
    {
      id: 12,
      type: 'action',
      text: 'Now, in the new design, navigate to the VMs Alert page using the new side menu.',
      task: 'third'
    }
  ],
  fourth : [{
    id: 13,
    type: 'action',
    text: 'Look at the current UI. Think about how easy it is to tell where you are or go back.',
    task: 'fourth'
  },
  {
    id: 14,
    type: 'action',
    text: 'Great! Now click on the Next button to move to the new design!',
    task: 'fourth'
  },
  {
    id: 15,
    type: 'action',
    text: 'Now, explore the new top bar with breadcrumbs. Think about how helpful they are and whether they change how you move around.',
    task: 'fourth'
  }
],

fifth : [{
  id: 16,
  type: 'action',
  text: 'Locate and open the existing search feature.',
  task: 'fifth'
},
{
  id: 17,
  type: 'action',
  text: 'Great! Now click on the Next button to move to the new design!',
  task: 'fifth'
},
{
  id: 18,
  type: 'action',
  text: 'Now, switch to the new design and try to open the search hub - either by finding it in the UI or using a keyboard shortcut. ',
  task: 'fifth'
},
{
  id: 19,
  type: 'action',
  text: 'Now, locate and open the new search hub. ',
  task: 'fifth'
}],
sixth : [{
  id: 20,
  type: 'action',
  text: 'Bookmark the VMs list page.',
  task: 'sixth'
},
{
  id: 21,
  type: 'action',
  text: 'Now, locate and open the bookmarks list.',
  task: 'sixth'
},
{
  id: 22,
  type: 'action',
  text: 'Great! Now click on the Next button to move to the new design! ',
  task: 'sixth'
},
{
  id: 23,
  type: 'action',
  text: 'Bookmark the VMs list page. ',
  task: 'sixth'
},
{
  id: 24,
  type: 'action',
  text: 'Now, locate and open the bookmarks list. ',
  task: 'sixth'
}]
  }
},
  survey: {
    completionTimestamp: 'end',
    list: [
      {
        name: 'Survey',
        paragraphs: [
          'You\'re done with the tasks! Now, to evaluate your experience, please fill out the following 9 statements and questions.'
        ],
        questions: {
          first : [{
            type: 'range',
            text: 'The redesigned dashboard is easy to use.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
          {
            type: 'range',
            text: 'The redesigned dashboard meets my needs.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
          {
            type: 'range',
            text: 'It’s easier to understand what each widget is showing compared to the previous dashboard.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
    
          {
            type: 'range',
            text: 'The updated visuals help me focus on important information more quickly.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
    
          {
            type: 'range',
            text: 'The redesigned dashboard feels more modern and polished than the current one.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
          {
            type: 'comment',
            text: 'What visual improvements (e.g. layout, colors, spacing, icons) would make this interface clearer or more efficient for you? '
          }],
            second : [{
              type: 'range',
              text: 'The redesigned dashboard is easy to use.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'The redesigned dashboard meets my needs.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'It’s easier to understand what each widget is showing compared to the previous dashboard.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
      
            {
              type: 'range',
              text: 'The updated visuals help me focus on important information more quickly.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
      
            {
              type: 'range',
              text: 'The redesigned dashboard feels more modern and polished than the current one.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'comment',
              text: 'What visual improvements (e.g. layout, colors, spacing, icons) would make this interface clearer or more efficient for you? '
          }],
            third : [{
              type: 'range',
              text: 'The new App & Domain switcher is easy to use.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'The new App & Domain switcher meets my needs.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'It’s easier to switch between Apps and Domains compared to the previous experience.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'The placement of the App & Domain switcher feels intuitive.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'The hierarchy between App, Domain, and Project is easy to understand.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'comment',
              text: 'What visual improvements (e.g. layout, colors, spacing, icons) would make this interface clearer or more efficient for you? '
          }],
            fourth : [{
              type: 'range',
              text: 'The new side menu is easy to use.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'The new side menu meets my needs.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'The hover behavior for triggering the menu feels smooth and predictable.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'The supporting information (subtitle) in the flyout menu is helpful.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'It’s easier to find what I need in the new side menu compared to the previous version.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'comment',
              text: 'What visual improvements (e.g. layout, colors, spacing, icons) would make this interface clearer or more efficient for you? '
          }],
    
            fifth : [{
              type: 'range',
              text: 'The new breadcrumb navigation is easy to use.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'The new breadcrumb navigation meets my needs.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'Breadcrumbs make it easier to understand where I am in the product.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'The labels and structure of the breadcrumbs are clear and helpful.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'It’s easier to move back to previous sections using breadcrumbs compared to the previous experience.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'comment',
              text: 'What visual improvements (e.g. layout, colors, spacing, icons) would make this interface clearer or more efficient for you? '
          }],
    
            sixth : [{
              type: 'range',
              text: 'The new search experience is easy to use.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'The new search experience meets my needs.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'Using Cmd + K (or Ctrl + K) to open the search hub would improve my workflow.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'The suggestions and quick actions in the new search hub are helpful.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'Having keyboard shortcuts shown in the search hub would be useful to me.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'comment',
              text: 'What visual improvements (e.g. layout, colors, spacing, icons) would make this interface clearer or more efficient for you? '
          }],
    
            seventh : [{
              type: 'range',
              text: 'The new bookmarking experience is easy to use.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'The new bookmarking experience meets my needs.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'range',
              text: 'The new bookmark page button was easy to find.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
    
            {
              type: 'range',
              text: 'The new bookmarks list was easy to find.',
              options: [ '1', '2', '3', '4', '5', '6', '7'],
              min: 'Strongly disagree',
              mid: '',
              max: 'Strongly agree'
            },
            {
              type: 'comment',
              text: 'What visual improvements (e.g. layout, colors, spacing, icons) would make this interface clearer or more efficient for you? '
          }],
          last : [{
            type: 'range',
            text: 'Overall, the redesigned experience is easy to use.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
          {
            type: 'range',
            text: 'Overall, the redesigned experience meets my needs.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
          {
            type: 'range',
            text: 'The new design is an improvement over the previous version.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
    
          {
            type: 'range',
            text: 'I would prefer using the new design over the previous version.',
            options: [ '1', '2', '3', '4', '5', '6', '7'],
            min: 'Strongly disagree',
            mid: '',
            max: 'Strongly agree'
          },
          {
            type: 'comment',
            text: 'What visual improvements (e.g. layout, colors, spacing, icons) would make this interface clearer or more efficient for you? '
        }
        ]
          }
    }
    ]
  },
  end: {
    title: 'Thank you for your feedback!',

    paragraphs: [
    "Your feedback is crucial as it helps us understand your experience and interactions with the My Nutanix. If you have any other feedback or thoughts, please feel free to reach out to me at ",
    { type: 'link', str: 'kunwei.jin@nutanix.com' },
    "."
  ]
  }
};

export default scenario;
